import { render, staticRenderFns } from "./ResolvedSlotsBox.vue?vue&type=template&id=a68cbcca&scoped=true"
import script from "./ResolvedSlotsBox.vue?vue&type=script&lang=js"
export * from "./ResolvedSlotsBox.vue?vue&type=script&lang=js"
import style0 from "./ResolvedSlotsBox.vue?vue&type=style&index=0&id=a68cbcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68cbcca",
  null
  
)

export default component.exports